export default __webpack_public_path__ + "static/media/settings.74b3d985.svg";